<template>
  <div class="featurelogs-container">
    <v-card flat class="futuristic-card">
      <div class="card-header">
        <h1 class="text-md-center earth-color">FEATURE TRACKER LOGS</h1>
        <div class="title-decoration"></div>
      </div>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field
          append-icon="search"
          placeholder="Search feature logs..."
          single-line
          hide-details
          v-model="search"
          class="futuristic-input"
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="featureColumns"
        :items="featureLogs"
        :search="search"
        :rows-per-page-items="[10,25,{'text':'All','value':-1}]"
        :disable-initial-sort="true"
        :loading="$loadingTrue"
        class="futuristic-table"
      >
        <v-progress-linear
          slot="progress"
          color="#587e27"
          indeterminate
          height="3"
        ></v-progress-linear>
        <template slot="items" slot-scope="props">
          <td>{{formated_date_time(props.item.created_at)}}</td>
          <td class="font-weight-medium">{{props.item.role}}</td>
          <td>{{props.item.feature_name}}</td>
          <td>
            <v-chip 
              small 
              :color="getActionColor(props.item.action)"
              text-color="white"
              class="action-chip"
            >
              {{ getActionText(props.item.action) }}
            </v-chip>
          </td>
          <td>{{props.item.action_by}}</td>
          <td>
            <v-icon 
              :color="getStatusColor(props.item.loggin_status_code)" 
              right 
              class="status-icon"
            >
              {{ getStatusIcon(props.item.loggin_status_code) }}
            </v-icon>
          </td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning" class="futuristic-alert">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table>

      <v-container class="action-buttons">
        <v-btn
          depressed
          @click="getMore()"
          color="#2196f3"
          :loading="this.$store.state.LoadingStore.loading"
          class="futuristic-btn"
        >
          <v-icon left>add</v-icon>
          GET MORE
        </v-btn>
        <v-btn
          depressed
          @click="getAllFeatureLogs()"
          color="#9e9e9e"
          :loading="this.$store.state.LoadingStore.loading"
          class="futuristic-btn"
        >
          <v-icon left>list</v-icon>
          GET ALL
        </v-btn>
      </v-container>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "FeatureTrackerLogs",
  data() {
    return {
      search: "",
      page: 2,
      featureColumns: [
        {
          text: "Done at",
          value: "created_at",
          class: "table-header"
        },
        {
          text: "Role",
          value: "role",
          class: "table-header"
        },
        {
          text: "Feature Name",
          value: "feature_name",
          class: "table-header"
        },
        {
          text: "Action",
          value: "action",
          class: "table-header"
        },
        {
          text: "Action by",
          value: "action_by",
          class: "table-header"
        },
        {
          text: "Status",
          class: "table-header"
        },
      ],
    };
  },
  created() {
    this.$store.dispatch("get_feature_logs");
  },
  methods: {
    getActionColor(action) {
      if (action === 1) return '#2ecc71';
      if (action === 0) return '#e74c3c';
      return '#9e9e9e';
    },
    getActionText(action) {
      if (action === 1) return 'Added Feature';
      if (action === 0) return 'Detached Feature';
      return 'Unknown Action';
    },
    getStatusColor(statusCode) {
      if (statusCode === 10) return '#44bd32';
      if (statusCode === 100) return '#ff5252';
      return '#9e9e9e';
    },
    getStatusIcon(statusCode) {
      if (statusCode === 10) return 'check_circle';
      if (statusCode === 100) return 'cancel';
      return 'help';
    },
    getMore() {
      this.loading = true;
      
      if (this.page === 2) {
        this.$store.dispatch("get_more_feature_logs", this.page);
        this.page = this.page + 1;
      } else {
        this.$store.dispatch("get_more_feature_logs", this.page);
        this.page = this.page + 1;
      }
    },
    getAllFeatureLogs() {
      this.loading = true;
      this.page = 0;
      this.$store.dispatch("get_more_feature_logs", this.page);
    },
  }
};
</script>

<style scoped>
.featurelogs-container {
  background: #ffffff;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.3s ease;
}

.featurelogs-container:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.earth-color {
  color: #587e27;
  font-weight: 600;
  margin: 0;
  font-size: 2rem;
}

.title-decoration {
  height: 4px;
  background: linear-gradient(90deg, #587e27, transparent);
  margin-bottom: 16px;
  width: 100px;
}

.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
  overflow: hidden;
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.futuristic-input >>> .v-input__slot {
  border-radius: 8px;
  background: #f5f7fa;
}

.futuristic-btn {
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
  transition: all 0.2s ease;
}

.futuristic-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.action-buttons {
  display: flex;
  gap: 12px;
  padding: 16px;
  background: #f5f7fa;
  border-radius: 0 0 8px 8px;
}

.action-chip {
  border-radius: 12px;
  font-weight: 500;
}

.status-icon {
  font-size: 20px;
}

.futuristic-alert {
  border-radius: 8px;
  margin: 16px;
}

/* Table styling */
.futuristic-table >>> thead tr th {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa) !important;
  color: #587e27 !important;
  font-weight: 600;
  font-size: 14px;
}

.futuristic-table >>> tbody tr:nth-of-type(even) {
  background-color: #f9f9f9;
}

.futuristic-table >>> tbody tr:hover {
  background-color: #f0f4f8 !important;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .featurelogs-container {
    padding: 12px;
  }

  .card-header {
    padding: 12px;
  }

  .earth-color {
    font-size: 1.75rem;
  }

  .action-buttons {
    flex-direction: column;
  }
}

@media (max-width: 600px) {
  .featurelogs-container {
    padding: 8px;
    border-radius: 6px;
  }

  .card-header {
    padding: 8px;
  }

  .earth-color {
    font-size: 1.5rem;
  }
}
</style>